module.exports = __webpack_public_path__ + "2b98018dbc829a42ba67c3f8af503383.svg";